import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private http: HttpClient) {}

  setAccessToken(token: string): void {
    localStorage.setItem('token', token);
  }

  setRefreshToken(refreshToken: string): void {
    localStorage.setItem('refresh', refreshToken);
  }

  getAccessToken(): string {
    return localStorage.getItem('token') || '';
  }

  getRefreshToken(): string {
    return localStorage.getItem('refresh') || '';
  }

  getTokenExpiration(token: string): number | null {
    if (!token) {
      return null;
    }

    try {
      // Split the token into its three parts: header, payload, signature
      const payload = token.split('.')[1];
      if (!payload) {
        return null;
      }

      // Decode the Base64 URL encoded string (handle padding and character replacements)
      const base64Url = payload.replace(/-/g, '+').replace(/_/g, '/');
      const base64 = base64Url + '='.repeat((4 - (base64Url.length % 4)) % 4); // Add padding
      const decodedPayload = atob(base64); // Decode the Base64 string
      // Parse the decoded payload as JSON
      const parsedPayload = JSON.parse(decodedPayload);
      // Return the expiration time if available
      if (parsedPayload.exp) {
        return parsedPayload.exp;
      }
    } catch (error) {
      console.error('Error parsing token payload:', error);
    }

    return null;
  }

  isTokenExpired(): boolean {
    const exp = this.getTokenExpiration(this.getAccessToken());
    const now = Math.floor(Date.now() / 1000);
    // se não tiver exp
    return !exp || now > exp;
  }

  isTokenWillExpireByTime(thresholdSeconds: number): boolean {
    const accessToken = this.getAccessToken();
    const exp = this.getTokenExpiration(accessToken);
    if (!exp) return true; 
    const now = Math.floor(Date.now() / 1000);
    return (exp - now) <= thresholdSeconds;
  }
}
